import { useState, useEffect, useContext } from "react";
import Drawer from "../drawer/Drawer.jsx";
import CustomButton from "../kits/custom-button/CustomButton";
import { CustomInput } from "../kits/inputs/Input.tsx";
import colorSchema from "../../assets/kits/colors";
import useAxios from "../../services/useAxios";
import { from } from "jalali-moment";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";

export default function NameDrawer({
  isOpen,
  setIsOpen,
  id,
  LastName,
  FirstName,
}) {
  const { execute: UpdateUsers } = useAxios("api/Update_Users");
  const [firstName, setFirstName] = useState(FirstName);
  const [lastName, setLastName] = useState(LastName);
  const auth = useContext(AuthenticationContext);
  const [errorText, setErrorText] = useState("نام  خود را وارد کنید");
  const [errorText2, setErrorText2] = useState(
    " نام خانوادگی خود را وارد کنید"
  );
  const [textType, setTextTyp] = useState("none");
  const [textType2, setTextTyp2] = useState("none");

  const checkName = () => {
    if (firstName == "" || lastName == "") {
      firstName == "" ? setTextTyp("error") : setTextTyp("none");
      lastName == "" ? setTextTyp2("error") : setTextTyp2("none");
    } else {
      UpdateUsers({
        conditions: `id/=/${id}`,
        keyvalues: `fname,${firstName}@@lname,${lastName}`,
      }).then((data) => {
        if (data.status == 1) {
          setIsOpen(false);
          auth.changeUserInfo({
            firstname: firstName,
            lastname: lastName,
          });
        }
      });
    }
  };

  return (
    <Drawer isOpen={isOpen} height={330} onClose={() => setIsOpen(false)}>
      <div>
        <h3
          className="title-h3-b mr-r-20 mr-t-16"
          style={{ color: colorSchema.foreground_background_he }}
        >
          ثبت نام و نام خانوادگی
        </h3>
        <div className="mr-t-16 mr-x-20" style={{ height: 80 }}>
          <CustomInput
            labelClassName="txt-t3-m"
            textType={textType}
            className="mr-y-4"
            title="نام"
            placeholder="نام خود را وارد کنید"
            messageText={errorText}
            value={firstName}
            onChange={(e) => {
              setFirstName(e.target.value);
            }}
          ></CustomInput>
        </div>
        <div className="mr-t-16 mr-x-20" style={{ height: 90 }}>
          <CustomInput
            labelClassName="txt-t3-m "
            textType={textType2}
            className="mr-y-4 mr-t-4"
            title="نام خانوادگی"
            placeholder="نام خانوادگی خود را وارد کنید"
            messageText={errorText2}
            value={lastName}
            onChange={(e) => {
              setLastName(e.target.value);
            }}
          ></CustomInput>
        </div>
        <div className="mr-x-20 mr-t-8">
          <CustomButton
            onClick={() => checkName()}
            style={{ width: "100%", height: "48px" }}
            buttonStyle="primary"
          >
            ثبت
          </CustomButton>
        </div>
      </div>
    </Drawer>
  );
}
